<script setup lang="ts">
const props = defineProps<{
  error?: string | boolean;
  options?: { label: string; value: string }[];
  placeholder?: string;
}>();

const model = defineModel<string>();

defineOptions({
  inheritAttrs: false,
});
</script>

<template>
  <div class="relative w-full">
    <select
      v-bind="$attrs"
      v-model="model"
      :class="[
        'w-full appearance-none rounded-[6px] border-0 px-4 py-3 text-sm font-medium text-on-primary-heading ring transition-colors outline-none ring-inset placeholder:text-on-primary-heading/40 focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-75 md:text-base',
        error ? 'ring-red-500' : 'ring-on-primary-heading',
        !model ? 'text-on-primary-heading/40' : 'text-on-primary-heading'
      ]"
    >
      <option v-if="placeholder" value="" disabled selected>{{ placeholder }}</option>
      <option v-for="option in options" :key="option.value" :value="option.value" class="text-on-primary-heading">
        {{ option.label }}
      </option>
    </select>
    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-on-primary-heading/40">
      <Icon name="material-symbols:keyboard-arrow-down" class="h-5 w-5" />
    </div>
  </div>
</template>
